import axios from "axios";
import ReactEcharts from "echarts-for-react";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";

const CompanySpacePieChart = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const [spaceData, setSpaceData] = useState(null);
    const [companyName, setCompanyName] = useState('');

    useEffect(() => {
        // Get user data from cookies
        const getCookie = (name) => {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        };

        // Try to get company name from cookies first
        const userCookie = getCookie('user');
        if (userCookie) {
            try {
                const userData = JSON.parse(userCookie);
                if (userData.companyName) {
                    setCompanyName(userData.companyName);
                }
            } catch (error) {
            }
        }
    })
    useEffect(() => {
        if(companyName)
        axios
            .get(`${BASE_API_URL}/comapny-space-info/${companyName}`)
            .then((response) => {
                const data = response.data;

                // Convert all values to MB
                const utilizedSpaceMB = data.utilizedSpace; // already in MB
                const additionalSpaceMB = data.additionalCreditSpace * 1024; // Convert GB to MB
                const availableSpaceMB = data["avaliable space"] * 1024;     // Convert GB to MB

                setSpaceData([
                    { value: utilizedSpaceMB, name: "Utilized Space", mb: utilizedSpaceMB, gb: (utilizedSpaceMB / 1024).toFixed(2) },
                    { value: additionalSpaceMB, name: "Additional Space", mb: additionalSpaceMB, gb: (additionalSpaceMB / 1024).toFixed(2) },
                    { value: availableSpaceMB, name: "Available Space", mb: availableSpaceMB, gb: (availableSpaceMB / 1024).toFixed(2) }
                ]);
            })
            .catch((error) => {
                console.log(" company name ++ "+companyName)
            });
    }, [companyName]);

    const chartOption = {

        tooltip: {
            trigger: "item",
            triggerOn: "mousemove",
            formatter: function (params) {
                return `${params.name}<br/>
                        ${params.data.mb.toFixed(2)} MB<br/>
                        ${params.data.gb} GB<br/>
                        ${params.percent}%`;
            }
        },
        legend: {
            orient: "vertical",
            right: "right"
        },
        color: ["#f36d12", "#04a9f4", "#a0b967"],
        series: [
            {
                name: "Storage",
                type: "pie",
                radius: "75%",
                center: ["50%", "60%"],
                data: spaceData || [],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)"
                    }
                }
            }
        ]
    };

    return (
        <>
            <Card body>
                <Card.Title style={{ textAlign: 'left' }}><strong>Jobbox Cloud : {companyName}</strong></Card.Title>

                <ReactEcharts style={{ width: '100%', height: '385px' }} option={chartOption} />
            </Card>
        </>
    );
};

export default CompanySpacePieChart;
